import { IAnalyticsEvent, InsightsEventData } from "../interfaces/Analytics";

import { post } from "./http";
import routeListen from "./routeListen";
import tokenStorageService from "./TokenStorageService";

//translations
import localisation from '../services/localisation';
import IL from '../interfaces/localisation';

function getStore(){
    return require("../Redux/store").store;
}

function buildEvent(eventType:string, eventData?:InsightsEventData):IAnalyticsEvent{
    const app = getStore().getState().app.app
    const content = getStore().getState().content.content

    let contentType = content?.type
        ? content?.type 
        : app.menu?.find(page => page.text === app.defaultContentTitle)?.type

    if (contentType === 'default') {
        contentType = '';
    }

    const contentTitle = content?.title ? content?.title : app.defaultContentTitle

    return {
        userId: checkIntVal(tokenStorageService?.getItem('userId')),
        eventType : eventType,
        eventData: {
            client: "web",
            channelGuid: routeListen.appGuid(),
            channelTitle: app?.name ? app.name : '',
            channelIconUrl: app?.settings?.icon ? app.settings.icon: '',
            contentId: checkIntVal(content.id ? content.id : app.defaultContentId),
            contentType: contentType || '',
            contentTitle: contentTitle || '',
            featuredImageUrl: content?.featuredImage?.url ? content?.featuredImage?.url : '',
            acknowledgementType: eventData?.acknowledgement?.type ? eventData?.acknowledgement?.type : '',
            state: eventData?.acknowledgement ? !!eventData?.acknowledgement.status : false,
            contentEventPayload : "",
            ...eventData?.overrideProps
        },
        eventOccurredAt: new Date().toISOString(),
        OSVersion: getOs(),
        AppVersion: getBrowser()
    }

    function checkIntVal(x:number | string | null) { 
        if(!x){
            return 0
        }
        if (isNaN(+x)){
            return 0;
        }
        else if (x){
            return +x;
        }
        return 0;
    }

}

// Request url - replaced by azure
function getURL():string {

    const url = '$__{RegisterInsightsUrl}__$';

    // Replaced production
    if (url.includes('http')){
        return url;
    }

    return 'https://insights-api.dev.thrive.app/Events'

}

function getOs():string{

    const np = navigator.userAgent;

    if (np.indexOf("Win") != -1) 
        return "Windows";

    if (np.indexOf("Mac") != -1) 
        return "Mac";

    if (np.indexOf("X11") != -1)
        return "UNIX";

    if (np.indexOf("Linux") != -1) 
        return "Linux";

    return ""
}

function getBrowser():string{

    const ua = navigator.userAgent;

    if (ua.indexOf("OPR/") > -1)
        return "Opera"
    
    else if (ua.indexOf("YaBrowser/") > -1)
        return "Yandex"

    else if(ua.indexOf("Edg/") > -1)
        return 'Edge'
    
    else if (ua.indexOf("Safari/") > -1 && ua.indexOf('Chrome') === -1)
        return "Safari"
    
    else if (ua.indexOf('Chrome/') > -1)
        return "Chrome"
    
    else if (ua.indexOf('Firefox/') > -1)
        return "Firefox"

    else if (ua.indexOf('Firefox/') === -1 && ua.indexOf('rv:') > -1)
        return 'Internet Explorer'
    return "Other"
}

function sendEvent (eventType:string, eventData?:InsightsEventData) {

    // Send insights event
    sendEventAsync(eventType, eventData)

}

async function sendEventAsync(eventType:string, eventData?:InsightsEventData){
    return post( getURL(), buildEvent(eventType,eventData ) )
    .catch(err => {
        console.error(localisation.getLocalString(IL['Errors.Error']), err);
    })
}

export {sendEvent, sendEventAsync}